import React from "react";
import { FaTrashAlt, FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import { IoCloseSharp, IoCheckmarkSharp, IoBusiness } from "react-icons/io5";
import FilledButton from "components/InterstellrComponents/FilledButton";
import { FaHashtag, FaPencil } from "react-icons/fa6";

const UsersItem = ({ item, onDelete, onChangeStatus, onEdit }) => {
  return (
    <>
      <div className="flex flex-col border relative border-slate-300 rounded-lg pb-12">
        {item?.profileImage ? (
          <img
            src={item?.profileImage}
            alt={item?.title}
            className="w-full h-40 object-cover rounded-t-lg"
          />
        ) : null}

        <div className="px-3 py-3">
          <h4 className="text-black h-12 font-medium text-base">
            {item?.firstname ?? ""} {item?.lastname ?? ""}
          </h4>

          {item?.supportCode ? (
            <div className="flex flex-row items-center justify-start">
              <FaHashtag />
              <p className="font-medium text-base ml-2">
                {item?.supportCode ?? ""}
              </p>
            </div>
          ) : null}

          <div className="flex flex-row items-center justify-start">
            <FaPhoneAlt />
            <p className="text-black font-normal text-base ml-2">
              {item?.mobile ?? ""}
            </p>
          </div>

          <div className="flex flex-row items-center justify-start">
            <FaEnvelope />
            <p className="text-black font-normal text-base ml-2">
              {item?.email ?? ""}
            </p>
          </div>

          {item?.company?.company_name ? (
            <div className="flex flex-row items-center justify-start">
              <IoBusiness className="text-[#5153F5]" />
              <p className="text-black font-normal text-base ml-2">
                {item?.company?.company_name ?? ""}
              </p>
            </div>
          ) : null}

          <p className="text-black font-normal text-base">
            Access:{" "}
            <span style={{ color: item?.status ? "green" : "red" }}>
              {item?.status ? "Enabled" : "Disabled"}
            </span>
          </p>
        </div>

        <div className="flex flex-row px-3 pb-3 absolute bottom-0 left-0 right-0">
          <div className="w-12">
            <FilledButton
              borderRadius={96}
              onPress={() => onDelete(item?._id)}
              backgroundColor="#FF0000"
              icon={<FaTrashAlt className="text-white" />}
            />
          </div>

          <div style={{ flex: 1 }} />

          <div className="w-12">
            <FilledButton
              borderRadius={96}
              backgroundColor="#5153F5"
              onPress={() => onEdit(item)}
              icon={<FaPencil color="#ffffff" />}
            />
          </div>

          <div style={{ flex: 1 }} />

          <div className="w-12">
            <FilledButton
              borderRadius={96}
              backgroundColor={item?.status ? "red" : "green"}
              onPress={() => onChangeStatus({ itemId: item?._id })}
              icon={
                item?.status ? (
                  <IoCloseSharp className="text-white" />
                ) : (
                  <IoCheckmarkSharp className="text-white" />
                )
              }
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default UsersItem;
